import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {CacheablesEntity} from "@ispm/core/entities/cacheables.entity";
import {WorkflowConfigModule} from "@ispm/workflow/workflow-config.module";

export class WorkflowDrivenCacheablesEntity extends  CacheablesEntity{
  protected constructor(payload) {
    super(payload);
  }

  public static builder(payload) {
    const instance = this as any;
    return new instance(payload);

  }

  protected generateIdentifier() {
    const workflowConfigService = WorkflowConfigModule.injector.get(WorkflowConfigService) as WorkflowConfigService;
    return workflowConfigService.getCacheKey().toPromise();
  }

  protected generateIdentifierSync() {
    const workflowConfigService = WorkflowConfigModule.injector.get(WorkflowConfigService) as WorkflowConfigService;
    return workflowConfigService.getCacheKeySync();
  }

}
